import template from './hipaaAuthorization.html';
import './hipaaAuthorization.less'

class HipaaAuthorizationController {
    constructor() {
    }

    $onInit() {
        this.datepickerOptions = {
            formatDay: 'd',
            showWeeks: false,
            minDate: new Date(),
            maxDate: new Date(),
        };
        this.userFullName = this.resolve.userFullName
        this.hipaaAuthorizedAt = this.resolve.hipaaAuthorizedAt
        this.hipaaAuthorizedVersion = '1'
    }

    onAgree() {
        this.close({
            $value: {
                hipaaAuthorized: true,
                hipaaAuthorizedAt: this.hipaaAuthorizedAt,
                hipaaAuthorizedVersion: this.hipaaAuthorizedVersion
            }
        })
    }

    onCancel() {
        this.dismiss({
            $value: {
                hipaaAuthorized: false,
                hipaaAuthorizedAt: this.hipaaAuthorizedAt,
                hipaaAuthorizedVersion: this.hipaaAuthorizedVersion
            }
        })
    }

}

export const HipaaAuthorizationComponent = {
    name: 'mmsHipaaAuthorization',
    component: {
        template: template,
        controller: HipaaAuthorizationController,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/common/hipaaAuthorization/hipaaAuthorization.component.js